import React from 'react';
import PropTypes from 'prop-types';

import { Text } from '@/shared/ui/elements';

import {
  ShiftLabelStyled,
  DateWrapper,
  LabelWrapper,
} from './ShiftLabel.styled';

const ShiftLabel = ({
  modifiers, content, date, isDisabled,
}) => (date || content) && (
  <LabelWrapper isDisabled={isDisabled}>
    {date && (
      <DateWrapper>
        <Text content={date} />
      </DateWrapper>
    )}
    {content && (
      <ShiftLabelStyled modifiers={modifiers}>
        <Text content={content} />
      </ShiftLabelStyled>
    )}
  </LabelWrapper>
);

ShiftLabel.propTypes = {
  content: PropTypes.string,
  date: PropTypes.string,
  modifiers: PropTypes.string,
};

ShiftLabel.defaultProps = {
  content: '',
  date: '',
  modifiers: '',
};

export default ShiftLabel;
